import * as ambassadorWixDataV1ExternalDatabaseConnection from './data-v1-external-database-connection-external-database-connections.http.js';
import * as ambassadorWixDataV1ExternalDatabaseConnectionTypes from './data-v1-external-database-connection-external-database-connections.types.js';
import * as ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes from './data-v1-external-database-connection-external-database-connections.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getExternalDatabaseConnection(): __PublicMethodMetaInfo<
  'GET',
  { name: string },
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.GetExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.GetExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.GetExternalDatabaseConnectionResponse,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.GetExternalDatabaseConnectionResponse
> {
  const payload = { name: ':name' } as any;

  const getRequestOptions =
    ambassadorWixDataV1ExternalDatabaseConnection.getExternalDatabaseConnection(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/external-database-connections/{name}',
    pathParams: { name: 'name' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listExternalDatabaseConnections(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.ListExternalDatabaseConnectionsRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.ListExternalDatabaseConnectionsRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.ListExternalDatabaseConnectionsResponse,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.ListExternalDatabaseConnectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1ExternalDatabaseConnection.listExternalDatabaseConnections(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/external-database-connections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createExternalDatabaseConnection(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.CreateExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.CreateExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.CreateExternalDatabaseConnectionResponse,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.CreateExternalDatabaseConnectionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1ExternalDatabaseConnection.createExternalDatabaseConnection(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/external-database-connections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExternalDatabaseConnection(): __PublicMethodMetaInfo<
  'PUT',
  { externalDatabaseConnectionName: string },
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.UpdateExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.UpdateExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.UpdateExternalDatabaseConnectionResponse,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.UpdateExternalDatabaseConnectionResponse
> {
  const payload = {
    externalDatabaseConnection: { name: ':externalDatabaseConnectionName' },
  } as any;

  const getRequestOptions =
    ambassadorWixDataV1ExternalDatabaseConnection.updateExternalDatabaseConnection(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/external-database-connections/{externalDatabaseConnection.name}',
    pathParams: {
      externalDatabaseConnectionName: 'externalDatabaseConnectionName',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteExternalDatabaseConnection(): __PublicMethodMetaInfo<
  'DELETE',
  { name: string },
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.DeleteExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.DeleteExternalDatabaseConnectionRequest,
  ambassadorWixDataV1ExternalDatabaseConnectionUniversalTypes.DeleteExternalDatabaseConnectionResponse,
  ambassadorWixDataV1ExternalDatabaseConnectionTypes.DeleteExternalDatabaseConnectionResponse
> {
  const payload = { name: ':name' } as any;

  const getRequestOptions =
    ambassadorWixDataV1ExternalDatabaseConnection.deleteExternalDatabaseConnection(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/external-database-connections/{name}',
    pathParams: { name: 'name' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ExternalDatabaseConnection as ExternalDatabaseConnectionOriginal,
  CauseOfFailure as CauseOfFailureOriginal,
  CauseOfFailureWithLiterals as CauseOfFailureWithLiteralsOriginal,
  CollectionsFound as CollectionsFoundOriginal,
  CollectionsFoundWithLiterals as CollectionsFoundWithLiteralsOriginal,
  FieldType as FieldTypeOriginal,
  FieldTypeWithLiterals as FieldTypeWithLiteralsOriginal,
  ConnectionStatus as ConnectionStatusOriginal,
  ProtocolVersion as ProtocolVersionOriginal,
  ProtocolVersionWithLiterals as ProtocolVersionWithLiteralsOriginal,
  Capabilities as CapabilitiesOriginal,
  GetExternalDatabaseConnectionRequest as GetExternalDatabaseConnectionRequestOriginal,
  GetExternalDatabaseConnectionResponse as GetExternalDatabaseConnectionResponseOriginal,
  ListExternalDatabaseConnectionsRequest as ListExternalDatabaseConnectionsRequestOriginal,
  Paging as PagingOriginal,
  ListExternalDatabaseConnectionsResponse as ListExternalDatabaseConnectionsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  CreateExternalDatabaseConnectionRequest as CreateExternalDatabaseConnectionRequestOriginal,
  ConnectionType as ConnectionTypeOriginal,
  ConnectionTypeWithLiterals as ConnectionTypeWithLiteralsOriginal,
  CreateExternalDatabaseConnectionResponse as CreateExternalDatabaseConnectionResponseOriginal,
  UpdateExternalDatabaseConnectionRequest as UpdateExternalDatabaseConnectionRequestOriginal,
  UpdateExternalDatabaseConnectionResponse as UpdateExternalDatabaseConnectionResponseOriginal,
  DeleteExternalDatabaseConnectionRequest as DeleteExternalDatabaseConnectionRequestOriginal,
  DeleteExternalDatabaseConnectionResponse as DeleteExternalDatabaseConnectionResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './data-v1-external-database-connection-external-database-connections.types.js';
